/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect, useMemo, useImperativeHandle, forwardRef, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormGroup, Accordion, Card } from 'react-bootstrap';
import Select from 'react-select';
import { uniqBy, set, get, isArray, cloneDeep, isEqualWith } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as colourAction from '../ColorLibary/store/ColorLibrary.action';
import CommonColorWayAdd from '../../../Components/CommonColorWay/CommonColorWayAdd';
import noImage from '../../../assets/images/no-image.png';
import { checkArray, customStyles, customStylesWhite } from '../../../Components/helper';
import * as libraryAction from './store/BomLibrary.action';
import { colourWaysPath, colurwaysAsSuppliersPath, colurwaysAsPlacementPath } from './fieldPath';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

const BomColourwaysComponent = forwardRef(function (props, ref) {
  const { libId, BomSuppliers, combinedDataArray, editState, searchText, showCombinationArray, placementList, isFromLibrary, setRemoveLibId } = props;

  const reducer = useSelector((estate) => estate);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const selectStyleOne = {
    ...customStylesWhite,
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      background: '#FFF',
      height: '28px',
      border: 'none',
    }),
  };
  const statusOptions = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
  ];

  const getStatusValueForMatch = (status) => {
    if (status == null || status === undefined) return null;
    if (typeof status === 'string') return status;
    if (typeof status === 'number') {
      if (status === 1) return 'Approved';
      if (status === 0) return 'Rejected';
      return 'Pending';
    }
    return null;
  };
  const prevBomsuppliers = usePrevious(BomSuppliers);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const { ColorLibraryDetails, BOMConfigDetails, SuppliersDetails } = reducer;
  const { ColorLibList } = ColorLibraryDetails;
  const { productDetails } = BOMConfigDetails;
  const { tier1List, productSupplier, factorySupplierList } = SuppliersDetails;
  const colorLibList = ColorLibList;
  const initialColourWaysObj = {
    colourWayId: null,
    colourRefsDataAsPerSuppliers: [
      {
        colourRef: null,
        colourRefNumber: '',
        supplier: null,
        comment: '',
        commentDate: null,
        approveBy: null,
        tier1Supplier: null,
        colourPlacement: null,
        componentSupplier: null,
        colourRefName: null,
        status: null,
      },
    ],
  };
  const [state, setState] = useState({
    colourWayRefsData: [cloneDeep(initialColourWaysObj)],
    addColorWay: false,
    errorState: {},
    filterColourwayRef: [],
    placementOptions: [],
  });
  const { colourWayRefsData, addColorWay, errorState, filterColourwayRef, placementOptions } = state;

  useEffect(() => {
    const initializeAndUpdateSuppliers = async () => {
      let initializedAccordions = [];

      if (editState?.data?.colourWayRefsData && Array.isArray(editState?.data?.colourWayRefsData)) {
        initializedAccordions = cloneDeep(editState?.data?.colourWayRefsData);
      } else {
        initializedAccordions = [cloneDeep(initialColourWaysObj)];
      }
      if (
        !editState?.mode &&
        !isFromLibrary &&
        Array.isArray(productDetails?.colourLibraries) &&
        productDetails?.colourLibraries.length > 0 &&
        colorLibList?.length > 0
      ) {
        const filteredColourWaysIsNotdeleted = colorLibList?.filter((element) => !element.isDeleted);
        const productColourLibraries = [];

        for (const clState of filteredColourWaysIsNotdeleted) {
          if (checkArray(productDetails?.colourLibraries)) {
            for (const ele of productDetails.colourLibraries) {
              if (clState?._id === ele) {
                productColourLibraries.push(clState);
              }
            }
          }
        }

        if (productColourLibraries.length > 0) {
          initializedAccordions = productColourLibraries.map((colourLib) => {
            return {
              colourWayId: colourLib,
              colourRefsDataAsPerSuppliers: [
                {
                  colourRef: colourLib,
                  colourRefNumber: '',
                  supplier: null,
                  comment: '',
                  commentDate: null,
                  approveBy: null,
                  tier1Supplier: null,
                  colourPlacement: null,
                  componentSupplier: null,
                  colourRefName: colourLib,
                  status: null,
                },
              ],
            };
          });
        }
      }

      if (initializedAccordions.length > 0) {
        if (placementList?.length > 0) {
          const placementData = placementList?.map((item) => ({
            name: item?.label,
            _id: item?.value,
          }));

          initializedAccordions?.forEach((item) => {
            item.colourRefsDataAsPerSuppliers?.forEach((subItem) => {
              const colourFoundInBOM = placementData?.find((placement) => placement._id === subItem?.colourPlacement?._id);

              if (subItem?.status === 1) {
                subItem.status = 'Approved';
              } else if (subItem?.status === 0) {
                subItem.status = 'Rejected';
              } else if (subItem?.status === null) {
                subItem.status = 'Pending';
              }

              if (!colourFoundInBOM) {
                subItem.colourPlacement = null;
              }
            });
          });
        } else {
          initializedAccordions?.forEach((item) => {
            item.colourRefsDataAsPerSuppliers?.forEach((subItem) => {
              subItem.colourPlacement = null;
            });
          });
        }

        if (editState?.data && !showCombinationArray && isArray(BomSuppliers) && BomSuppliers.length > 0) {
          await functionToUpdateComponentSupplier(initializedAccordions);
        }

        setState((prev) => ({
          ...prev,
          colourWayRefsData: initializedAccordions,
        }));
      }
    };

    initializeAndUpdateSuppliers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDetails?.colourLibraries, colorLibList, editState?.data, showCombinationArray, isFromLibrary]);

  useEffect(() => {
    if (placementList?.length > 0) {
      const placementData = placementList?.map((item) => ({
        name: item?.label,
        _id: item?.value,
      }));
      setState((prev) => ({
        ...prev,
        placementOptions: placementData,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        placementOptions: [],
      }));
    }
  }, [placementList]);

  const hasAllColourLibrariesUsed = () => {
    if (!productDetails?.colourLibraries || productDetails.colourLibraries.length === 0) {
      return true;
    }

    const usedColourWayIds = colourWayRefsData.map((item) => item?.colourWayId?._id?.toString() || item?.colourWayId?.toString()).filter(Boolean);

    return productDetails.colourLibraries.every((libraryId) => usedColourWayIds.includes(libraryId?.toString()));
  };

  // while seacrg filtereing the colourways array
  const filterColourwadRef = (value) => {
    if (value) {
      const cloneColourwaysRef = colourWayRefsData;
      const filteredData = cloneColourwaysRef.filter((vl) => {
        return (
          vl?.colourWayId?.name?.toLowerCase().includes(value?.toLowerCase()) ||
          vl.colourRefsDataAsPerSuppliers.some(
            (colour) =>
              colour?.colourRef?.name?.toLowerCase().includes(value.toLowerCase()) ||
              colour?.colourRefName?.newReferences?.toLowerCase().includes(value.toLowerCase()) ||
              colour?.componentSupplier?.name?.toLowerCase().includes(value.toLowerCase()) ||
              colour?.tier1Supplier?.name?.toLowerCase().includes(value.toLowerCase()),
          )
        );
      });
      setState((prev) => ({ ...prev, filterColourwayRef: filteredData }));
      return filteredData;
    }
    setState((prev) => ({ ...prev, filterColourwayRef: [] }));
    return [];
  };
  // check vlidation while adding for each and every index of colouways ref
  const checkValidation = () => {
    const cloneColourwaysRef = colourWayRefsData;
    const checSimilarExistOrNot = Object.keys(checkSimilarColourwaysRefExist).length > 0;
    const errors = {};
    let hasError = false;
    for (const [inde, colourref] of cloneColourwaysRef.entries()) {
      if (colourref?.colourWayId) {
        if (Array.isArray(colourref?.colourRefsDataAsPerSuppliers) && colourref?.colourRefsDataAsPerSuppliers?.length > 0) {
          for (const [chInde, colourwayRefSupp] of colourref.colourRefsDataAsPerSuppliers.entries()) {
            if (!colourwayRefSupp.componentSupplier && showCombinationArray) {
              hasError = true;
              set(errors, `[${inde}][${chInde}].componentSupplier`, 'Component Supplier is required');
            }
            if (!colourwayRefSupp.tier1Supplier && showCombinationArray) {
              hasError = true;
              set(errors, `[${inde}][${chInde}].tier1Supplier`, 'Product Supplier is required');
            }
          }
        }
      }
    }
    if (checSimilarExistOrNot) {
      hasError = true;
    }
    setState((prev) => ({ ...prev, errorState: errors }));
    return hasError;
  };

  useImperativeHandle(ref, () => ({
    getState() {
      return state;
    },
    validateColourways() {
      return checkValidation();
    },
    filterColourways(value) {
      return filterColourwadRef(value);
    },
  }));

  const addNewColourArtWork = (index) => {
    const cloneColourWayRefsData = state.colourWayRefsData;
    cloneColourWayRefsData[index].colourRefsDataAsPerSuppliers.push({
      colourRef: null,
      colourRefNumber: '',
      supplier: null,
      comment: '',
      commentDate: null,
      approveBy: null,
      tier1Supplier: null,
      componentSupplier: null,
      colourRefName: null,
      status: null,
    });
    setState((prev) => ({
      ...prev,
      colourWayRefsData: cloneColourWayRefsData,
    }));
  };

  const removeColourArtWork = (index, chilIndex) => {
    const cloneColourWayRefsData = state.colourWayRefsData;
    cloneColourWayRefsData[index]?.colourRefsDataAsPerSuppliers.splice(chilIndex, 1);
    setState((prev) => ({
      ...prev,
      colourWayRefsData: cloneColourWayRefsData,
    }));
  };

  const ifHasColourwayImage = (colourwayId) => {
    const findColourwasy = colorLibList?.find((vl) => vl?._id === colourwayId);
    return findColourwasy?.image ? `${findColourwasy?.image}` : noImage;
  };

  const handleChangeColorWay = async (value, path, subKey) => {
    const cloneColourWayRefsData = cloneDeep(state?.colourWayRefsData);
    if (path.includes('colourWayId')) {
      await dispatch(
        libraryAction.fetchColourWayDocs({
          colourId: value?._id,
        }),
      );

      const colourRefPath = path.replace('[colourWayId]', '[colourRefsDataAsPerSuppliers][0][colourRef]');
      const colourRefNamePath = path.replace('[colourWayId]', '[colourRefsDataAsPerSuppliers][0][colourRefName]');

      if (value) {
        const isValidOption = colourWaysListNameRefMemo?.some((option) => option?._id === value?._id);

        if (isValidOption) {
          set(cloneColourWayRefsData, colourRefPath, value);
          set(cloneColourWayRefsData, colourRefNamePath, value);
        }
      } else {
        set(cloneColourWayRefsData, colourRefPath, null);
        set(cloneColourWayRefsData, colourRefNamePath, null);
      }
    }
    if (path.endsWith('[colourRef]')) {
      const refNamePath = path.replace(/\[colourRef\]$/, '[colourRefName]');
      set(cloneColourWayRefsData, refNamePath, value);

      const libraryColourWays = editState?.data?.libraryColourWays;
      if (Array.isArray(libraryColourWays) && libraryColourWays.length > 0 && value?._id) {
        const selectedColourRefId = typeof value === 'object' ? value._id : value;
        let foundStatus = null;

        libraryColourWays.forEach((item) => {
          if (Array.isArray(item?.colourRefsDataAsPerSuppliers)) {
            item.colourRefsDataAsPerSuppliers.forEach((subItem) => {
              const colourRefId = subItem.colourRef;
              if (colourRefId === selectedColourRefId && subItem?.status !== undefined) {
                if (subItem.status === 1) {
                  foundStatus = 'Approved';
                } else if (subItem.status === 0) {
                  foundStatus = 'Rejected';
                } else {
                  foundStatus = 'Pending';
                }
              }
            });
          }
        });

        if (foundStatus !== null) {
          const statusPath = path.replace(/\[colourRef\]$/, '[status]');
          set(cloneColourWayRefsData, statusPath, foundStatus);
        }
      }
    }
    set(cloneColourWayRefsData, path, value);

    setState((prev) => ({ ...prev, errorState: {} }));
    if (subKey === 'tier1Supplier') {
      await functionToUpdateComponentSupplier(cloneColourWayRefsData);
    } else {
      setState((prev) => ({
        ...prev,
        colourWayRefsData: cloneColourWayRefsData,
      }));
    }
  };

  const handleToggleColorPopup = async (e) => {
    if (e) {
      e.preventDefault();
    }
    await dispatch(colourAction.clearReducer());
    setState((prev) => ({
      ...prev,
      addColorWay: !prev.addColorWay,
    }));
  };

  const colourWaysListNameRefMemo = useMemo(() => {
    let colourWaysList = [];

    if (Array.isArray(colorLibList) && colorLibList.length > 0) {
      const filteredColourWaysIsNotdeleted = colorLibList?.filter((element) => !element.isDeleted);

      const libraryColourWays = editState?.data?.libraryColourWays;
      if (
        !isFromLibrary &&
        Array.isArray(libraryColourWays) &&
        libraryColourWays.length > 0 &&
        libraryColourWays.some(
          (item) =>
            Array.isArray(item?.colourRefsDataAsPerSuppliers) &&
            item.colourRefsDataAsPerSuppliers.some((subItem) => subItem?.colourRef || subItem?.colourRefName),
        )
      ) {
        const colourRefIds = new Set();

        libraryColourWays.forEach((item) => {
          if (Array.isArray(item?.colourRefsDataAsPerSuppliers)) {
            item.colourRefsDataAsPerSuppliers.forEach((subItem) => {
              if (!subItem?.colourRef && !subItem?.colourRefName) {
                return;
              }

              if (subItem.colourRef) {
                const colourRefId = typeof subItem.colourRef === 'object' ? subItem.colourRef._id : subItem.colourRef;
                if (colourRefId) colourRefIds.add(colourRefId);
              }
              if (subItem.colourRefName) {
                const colourRefNameId = typeof subItem.colourRefName === 'object' ? subItem.colourRefName._id : subItem.colourRefName;
                if (colourRefNameId) colourRefIds.add(colourRefNameId);
              }
            });
          }
        });
        colourWaysList = filteredColourWaysIsNotdeleted.filter((element) => colourRefIds.has(element._id));
      } else if (isFromLibrary) {
        colourWaysList = filteredColourWaysIsNotdeleted;
      } else {
        colourWaysList = filteredColourWaysIsNotdeleted;
      }
    }

    return colourWaysList;
  }, [colorLibList, isFromLibrary, editState?.data]);
  const isEdited = useMemo(() => !isEqualWith(initialColourWaysObj, state.colourWayRefsData[0]), [initialColourWaysObj, state.colourWayRefsData]);

  // product supplier options list memo
  const t1SupplierListOptionsMemo = useMemo(() => {
    let tierSupplierList = [];
    if (libId === undefined) {
      if (Array.isArray(tier1List) && tier1List.length > 0) {
        tierSupplierList = tier1List;
      }
    } else if (Array.isArray(productSupplier) && productSupplier.length > 0) {
      tierSupplierList = uniqBy([...productSupplier], '_id');
    }
    return tierSupplierList;
  }, [tier1List, productSupplier, libId]);

  const functionToUpdateComponentSupplier = async (array) => {
    const cloneColourRef = array ? cloneDeep(array) : cloneDeep(colourWayRefsData);
    const manipulatedColourRefData = [];
    if (isArray(cloneColourRef) && cloneColourRef.length > 0) {
      for (const colur of cloneColourRef) {
        if (colur?.colourWayId) {
          if (isArray(colur?.colourRefsDataAsPerSuppliers) && colur?.colourRefsDataAsPerSuppliers.length > 0) {
            const manipulatedColourRefAsAupplier = [];
            for (const colourRef of colur?.colourRefsDataAsPerSuppliers || []) {
              const objs = {
                ...colourRef,
                componentSuppliersOPtionsMemo: BomSuppliers,
              };
              if (prevBomsuppliers && BomSuppliers && colourRef?.componentSupplier && prevBomsuppliers[0]?._id !== BomSuppliers[0]?._id) {
                objs.componentSupplier = BomSuppliers;
              }
              manipulatedColourRefAsAupplier.push(objs);
            }
            colur.colourRefsDataAsPerSuppliers = manipulatedColourRefAsAupplier;
          }
        }
        manipulatedColourRefData.push(colur);
      }
    }
    setState((prev) => ({
      ...prev,
      colourWayRefsData: manipulatedColourRefData,
    }));
  };

  useEffect(() => {
    const updateComponentSuppliersOnChange = async () => {
      if (
        isArray(BomSuppliers) &&
        BomSuppliers.length > 0 &&
        !editState?.data &&
        isArray(prevBomsuppliers) &&
        ((prevBomsuppliers.length > 0 && BomSuppliers[0]?._id !== prevBomsuppliers[0]?._id) || BomSuppliers[0]?._id !== prevBomsuppliers)
      ) {
        await functionToUpdateComponentSupplier();
      }
    };

    updateComponentSuppliersOnChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BomSuppliers, editState?.data, prevBomsuppliers]);

  const componentSuppliersOPtionsMemo = useMemo(() => {
    let componentSuppliers = [];
    if (Array.isArray(combinedDataArray) && combinedDataArray.length > 0 && combinedDataArray?.[0]?.componentSupplier) {
      const combinationArray = combinedDataArray?.filter((vl) => vl?.componentSupplier).map((vl) => vl?.componentSupplier);
      componentSuppliers = uniqBy([...combinationArray], 'name');
    } else if (Array.isArray(BomSuppliers) && BomSuppliers.length > 0) {
      componentSuppliers = [...BomSuppliers];
    }
    return componentSuppliers;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factorySupplierList, combinedDataArray, BomSuppliers]);

  useEffect(() => {
    return () => {
      setState((prev) => ({
        ...prev,
        colourWayRefsData: [cloneDeep(initialColourWaysObj)],
        addColorWay: false,
      }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredCheckColourwarRefsData = useMemo(() => {
    if (searchText) return filterColourwayRef;
    return colourWayRefsData;
  }, [searchText, filterColourwayRef, colourWayRefsData]);

  const formatParentColourwayOptionLabel = (option, { context }) => (context !== 'value' ? `${option.name} | ${option.newReferences}` : option.name);

  const formatChildRefColourwayOptionLabel = (option, { context }) => (context !== 'value' ? `${option.name} | ${option.newReferences}` : option.newReferences);

  const disabledCompoenntSupplier = useMemo(() => {
    const filteredCombinationArr = combinedDataArray?.filter((vl) => vl?.componentSupplier).map((vl) => vl?.componentSupplier);
    let isComponentSupplierDisabled = false;
    if (showCombinationArray && !(Array.isArray(filteredCombinationArr) && filteredCombinationArr.length > 0)) {
      isComponentSupplierDisabled = true;
    }
    return isComponentSupplierDisabled;
  }, [showCombinationArray, combinedDataArray]);

  // changes component supplier in all array of objects when you add 1st combination array for product supplier and combination supplier in multiple supplier section
  useMemo(() => {
    const filteredCombinationArr = combinedDataArray?.filter((vl) => vl?.componentSupplier).map((vl) => vl?.componentSupplier);

    if (showCombinationArray && Array.isArray(filteredCombinationArr) && filteredCombinationArr.length === 1) {
      const manipulatedColourRefData = [];

      const cloneColourRef = cloneDeep(colourWayRefsData);
      if (isArray(cloneColourRef) && cloneColourRef.length > 0) {
        for (const colur of cloneColourRef) {
          if (colur?.colourWayId) {
            if (isArray(colur?.colourRefsDataAsPerSuppliers) && colur?.colourRefsDataAsPerSuppliers.length > 0) {
              const manipulatedColourRefAsAupplier = [];
              for (const colourRef of colur.colourRefsDataAsPerSuppliers) {
                const objs = {
                  ...colourRef,
                  componentSupplier: filteredCombinationArr[0],
                };
                manipulatedColourRefAsAupplier.push(objs);
              }
              colur.colourRefsDataAsPerSuppliers = manipulatedColourRefAsAupplier;
            }
          }
          manipulatedColourRefData.push(colur);
        }
      }
      setState((prev) => ({
        ...prev,
        colourWayRefsData: manipulatedColourRefData,
      }));
    } else if (showCombinationArray && Array.isArray(filteredCombinationArr) && filteredCombinationArr.length > 1) {
      const manipulatedColourRefData = [];

      const cloneColourRef = cloneDeep(colourWayRefsData);

      if (isArray(cloneColourRef) && cloneColourRef.length > 0) {
        for (const colur of cloneColourRef) {
          if (colur?.colourWayId) {
            if (isArray(colur?.colourRefsDataAsPerSuppliers) && colur?.colourRefsDataAsPerSuppliers.length > 0) {
              const manipulatedColourRefAsAupplier = [];
              for (const colourRef of colur.colourRefsDataAsPerSuppliers) {
                const objs = {
                  ...colourRef,
                  componentSupplier: null,
                };
                manipulatedColourRefAsAupplier.push(objs);
              }
              colur.colourRefsDataAsPerSuppliers = manipulatedColourRefAsAupplier;
            }
          }
          manipulatedColourRefData.push(colur);
        }
      }
      setState((prev) => ({
        ...prev,
        colourWayRefsData: manipulatedColourRefData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCombinationArray, factorySupplierList, combinedDataArray]);

  useMemo(() => {
    const filteredCombinationArr = combinedDataArray?.filter((vl) => vl?.componentSupplier).map((vl) => vl?.componentSupplier);
    if (Array.isArray(filteredCombinationArr) && filteredCombinationArr.length === 0 && Array.isArray(BomSuppliers) && BomSuppliers.length === 0) {
      const manipulatedColourRefData = [];

      const cloneColourRef = cloneDeep(colourWayRefsData);
      if (isArray(cloneColourRef) && cloneColourRef.length > 0) {
        for (const colur of cloneColourRef) {
          if (colur?.colourWayId) {
            if (isArray(colur?.colourRefsDataAsPerSuppliers) && colur?.colourRefsDataAsPerSuppliers.length > 0) {
              const manipulatedColourRefAsAupplier = [];
              for (const colourRef of colur.colourRefsDataAsPerSuppliers) {
                const objs = {
                  ...colourRef,
                  componentSupplier: null,
                };
                manipulatedColourRefAsAupplier.push(objs);
              }
              colur.colourRefsDataAsPerSuppliers = manipulatedColourRefAsAupplier;
            }
          }
          manipulatedColourRefData.push(colur);
        }
      }
      setState((prev) => ({
        ...prev,
        colourWayRefsData: manipulatedColourRefData,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [BomSuppliers, combinedDataArray]);
  // check colourways has similar coourwayref suppliers on each index
  // Sample input data (replace with your actual data)

  // Function to group and merge arrays based on colourWayId._id
  function groupAndMerge(data) {
    const resultMap = new Map();

    data?.forEach((doc) => {
      const colourWayId = doc?.colourWayId?._id;
      const existingDoc = resultMap?.get(colourWayId);
      if (existingDoc) {
        existingDoc.colourRefsDataAsPerSuppliers = existingDoc.colourRefsDataAsPerSuppliers || [];
        if (doc?.colourRefsDataAsPerSuppliers) {
          existingDoc.colourRefsDataAsPerSuppliers.push(...doc.colourRefsDataAsPerSuppliers);
        }
      } else {
        resultMap?.set(colourWayId, { ...doc });
      }
    });

    return [...resultMap.values()];
  }
  // Call the function and get the grouped and merged result

  const checkSimilarColourwaysRefExist = useMemo(() => {
    const showSimilarExist = {};
    let newClonedData = cloneDeep(filteredCheckColourwarRefsData);
    newClonedData = groupAndMerge(newClonedData);
    if (Array.isArray(newClonedData) && newClonedData.length > 0) {
      for (let i = 0; i < newClonedData.length; i++) {
        const coloursRef = newClonedData[i];
        const { colourRefsDataAsPerSuppliers } = coloursRef;
        const duplicates = {};
        for (let j = 0; j < colourRefsDataAsPerSuppliers?.length; j++) {
          const currentData = colourRefsDataAsPerSuppliers[j];
          const currentKey = `${currentData?.colourRef?._id}-${currentData?.tier1Supplier?._id}-${currentData?.componentSupplier?._id}-${currentData?.colourRefName?._id}`;

          if (duplicates[currentKey]) {
            currentData.isDuplicate = true;
            duplicates[currentKey].isDuplicate = true;
          } else {
            duplicates[currentKey] = currentData;
            currentData.isDuplicate = false;
          }
        }
        if (Object.values(duplicates).some((data) => data.isDuplicate)) {
          showSimilarExist[i] = true;
        }
      }
    }
    return showSimilarExist;
  }, [filteredCheckColourwarRefsData]);

  const colourWaysListMemo = useMemo(() => {
    let colourWaysList = [];
    if (Array.isArray(colorLibList) && colorLibList.length > 0) {
      const filteredColourWaysIsNotdeleted = colorLibList?.filter((element) => !element.isDeleted);
      const filteredproductColourLibraries = [];
      for (const clState of filteredColourWaysIsNotdeleted) {
        if (checkArray(productDetails?.colourLibraries)) {
          for (const ele of productDetails.colourLibraries) {
            if (clState?._id?.toString() === ele?.toString()) {
              filteredproductColourLibraries.push(clState);
            }
          }
        }
      }
      colourWaysList = uniqBy([...filteredproductColourLibraries], 'name');
    }
    return colourWaysList;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorLibList, productDetails?.colourLibraries, filteredCheckColourwarRefsData?.length]);

  const removeColourRefObj = (index) => {
    const cloneColourWayRefsData = state.colourWayRefsData;
    if (cloneColourWayRefsData?.[index]?._id) {
      setRemoveLibId(cloneColourWayRefsData?.[index]?.colourWayId?._id);
    }
    cloneColourWayRefsData.splice(index, 1);
    setState((prev) => ({
      ...prev,
      colourWayRefsData: cloneColourWayRefsData,
    }));
  };

  const resetColorObj = () => {
    setState((prev) => ({
      ...prev,
      colourWayRefsData: [cloneDeep(initialColourWaysObj)],
    }));
  };

  const addNewColourRefObj = () => {
    const cloneColourWayRefsData = state.colourWayRefsData;
    cloneColourWayRefsData.push(cloneDeep(initialColourWaysObj));
    setState((prev) => ({
      ...prev,
      colourWayRefsData: cloneColourWayRefsData,
    }));
  };
  return (
    <>
      {Array.isArray(filteredCheckColourwarRefsData) && filteredCheckColourwarRefsData?.length > 0
        ? filteredCheckColourwarRefsData?.map((ele, colInd) => {
            return (
              <div key={colInd} className="collapse-card add-bom-accordion">
                <Accordion defaultActiveKey="0">
                  <Card className="bom-add-card">
                    <div className="btn-sidebyside">
                      <Card.Header className="colour-header">
                        <div className="colourway-header colourway-collapse">
                          {!isFromLibrary && (
                            <>
                              <img
                                width="32"
                                height="32"
                                alt="poster"
                                className="img-responsive color-image"
                                src={ifHasColourwayImage(ele?.colourWayId?._id)}
                              />
                              <div className="colour-select-bom">
                                <Select
                                  name="colourWayId"
                                  options={colourWaysListMemo}
                                  getOptionLabel={(option) => `${option?.name} | ${option?.newReferences}`}
                                  getOptionValue={(option) => `${option._id}`}
                                  isOptionDisabled={(option) => option.isDisable}
                                  value={ele?.colourWayId}
                                  onChange={(selected) => handleChangeColorWay(selected, colourWaysPath(colInd, 'colourWayId').COMMONPATH)}
                                  formatOptionLabel={formatParentColourwayOptionLabel}
                                  styles={selectStyleOne}
                                  placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COLOUR_ARTWORK')}
                                  isClearable
                                  className=""
                                  classNamePrefix="common-select"
                                  menuPosition="fixed"
                                />
                              </div>
                              {!searchText ? (
                                <div>
                                  {colourWayRefsData.length - 1 === colInd && !hasAllColourLibrariesUsed() && (
                                    <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                                      <button
                                        type="button"
                                        className="btn bg-white add-colour-icon p-0"
                                        aria-label="add"
                                        onClick={addNewColourRefObj}
                                        href={() => false}
                                      >
                                        <i className="icon-Add" />
                                      </button>
                                    </CustomTooltip>
                                  )}
                                  {(colourWayRefsData?.length !== 1 || isEdited) && (
                                    <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                                      <button
                                        type="button"
                                        aria-label="add"
                                        onClick={() => {
                                          colourWayRefsData.length === 1 && isEdited ? resetColorObj() : removeColourRefObj(colInd);
                                        }}
                                        className="btn bg-white add-colour-icon p-0"
                                      >
                                        <i className="icon-Delete" />
                                      </button>
                                    </CustomTooltip>
                                  )}
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                      </Card.Header>

                      <Accordion.Collapse className="edit-collapse" eventKey="0">
                        <Card.Body className="colour-bom-collapse">
                          {Array.isArray(ele?.colourRefsDataAsPerSuppliers) && ele?.colourRefsDataAsPerSuppliers.length > 0
                            ? ele?.colourRefsDataAsPerSuppliers?.map((suppColouref, chInd) => (
                                <div className="bottom-section " key={chInd}>
                                  <div className="left">
                                    <div className="row color-row align-items-center">
                                      <div className="multi-image-container">
                                        <img
                                          alt="poster"
                                          width="80"
                                          height="80"
                                          className="img-responsive img-one"
                                          src={ifHasColourwayImage(suppColouref?.colourRef?._id)}
                                        />
                                      </div>
                                      <div className="col  add-form">
                                        <div className="d-flex">
                                          <FormGroup className="flex-fill mt-2 mt-md-0 m-0">
                                            <div className="custom-react-select mb-0 common-react-select">
                                              <label
                                                htmlFor={`select_${colInd}_${chInd}`}
                                                className={`field-lbl bom-form-title bom-select-form ${!isFromLibrary ? 'asterisk-req' : ''}`}
                                              >
                                                {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COLUR_ARTWORK_NAME')}
                                              </label>
                                              <Select
                                                options={colourWaysListNameRefMemo}
                                                getOptionLabel={(option) => `${option?.name} | ${option?.newReferences}`}
                                                getOptionValue={(option) => `${option._id}`}
                                                value={suppColouref?.colourRef}
                                                formatOptionLabel={formatParentColourwayOptionLabel}
                                                onChange={(selected) =>
                                                  handleChangeColorWay(selected, colurwaysAsSuppliersPath(colInd, chInd, 'colourRef').COLOURWAY_AS_SUPPLIERS)
                                                }
                                                isDisabled={!isFromLibrary && !ele?.colourWayId}
                                                styles={customStyles}
                                                menuPosition="fixed"
                                                placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COLUR_ARTWORK_NAME')}
                                                isClearable
                                                className="common-select"
                                                classNamePrefix="common-select"
                                              />
                                            </div>
                                            <span className="error-message">{get(errorState, `[${colInd}][${chInd}].colourRef`, '')}</span>
                                          </FormGroup>
                                          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                                            <button
                                              className="btn mr-0 btn-add-bom-colourway btn-outline"
                                              type="button"
                                              aria-label="add"
                                              style={{ right: 13 }}
                                              onClick={(e) => handleToggleColorPopup(e)}
                                            >
                                              <i className="icon-Add" />
                                            </button>
                                          </CustomTooltip>
                                        </div>
                                      </div>

                                      <div className="col add-form">
                                        <FormGroup className="m-0">
                                          <div className="custom-react-select mb-0 common-react-select">
                                            <label
                                              htmlFor="colorRefName"
                                              className={`field-lbl bom-select-form bom-form-title ${!isFromLibrary ? 'asterisk-req' : ''}`}
                                            >
                                              {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COLOUR_ARTWORK_REF')}
                                            </label>
                                            <Select
                                              options={colourWaysListNameRefMemo}
                                              getOptionLabel={(option) => `${option?.name} | ${option?.newReferences}`}
                                              getOptionValue={(option) => `${option._id}`}
                                              formatOptionLabel={formatChildRefColourwayOptionLabel}
                                              value={suppColouref?.colourRefName}
                                              onChange={(selected) =>
                                                handleChangeColorWay(selected, colurwaysAsSuppliersPath(colInd, chInd, 'colourRefName').COLOURWAY_AS_SUPPLIERS)
                                              }
                                              isDisabled
                                              styles={customStyles}
                                              placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COLOUR_ARTWORK_REF')}
                                              isClearable
                                              className="common-select"
                                              classNamePrefix="common-select"
                                              menuPosition="fixed"
                                            />
                                          </div>
                                          <span className="error-message">{get(errorState, `[${colInd}][${chInd}].colourRefName`, '')}</span>
                                        </FormGroup>
                                      </div>

                                      <div className="col add-form">
                                        <FormGroup className="m-0">
                                          <div className="custom-react-select common-react-select">
                                            <label htmlFor="status" className="field-lbl bom-select-form bom-form-title">
                                              {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.STATUS')}
                                            </label>
                                            <Select
                                              options={statusOptions}
                                              getOptionLabel={(option) => option?.label}
                                              getOptionValue={(option) => option?.value}
                                              value={statusOptions?.find((opt) => opt?.value === getStatusValueForMatch(suppColouref?.status)) || null}
                                              onChange={(selected) =>
                                                handleChangeColorWay(
                                                  selected?.value || null,
                                                  colurwaysAsSuppliersPath(colInd, chInd, 'status').COLOURWAY_AS_SUPPLIERS,
                                                )
                                              }
                                              isDisabled={!isFromLibrary && !ele?.colourWayId}
                                              styles={customStyles}
                                              placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.SELECT_STATUS')}
                                              isClearable
                                              className="common-select"
                                              classNamePrefix="common-select"
                                              menuPosition="fixed"
                                            />
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col add-form">
                                        <FormGroup className="m-0">
                                          <div className="custom-react-select common-react-select">
                                            <label htmlFor="placement" className="field-lbl bom-select-form bom-form-title asterisk-req">
                                              {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.PLACEMENT')}
                                            </label>
                                            <Select
                                              options={placementOptions}
                                              getOptionLabel={(option) => `${option?.name}`}
                                              getOptionValue={(option) => `${option._id}`}
                                              value={suppColouref?.colourPlacement}
                                              onChange={(selected) =>
                                                handleChangeColorWay(
                                                  selected,
                                                  colurwaysAsPlacementPath(colInd, chInd, 'colourPlacement').COLOURWAY_AS_SUPPLIERS,
                                                )
                                              }
                                              isDisabled={!isFromLibrary && !ele?.colourWayId}
                                              styles={customStyles}
                                              placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.PLACEMENT')}
                                              isClearable
                                              className="common-select"
                                              classNamePrefix="common-select"
                                              menuPosition="fixed"
                                            />
                                          </div>
                                        </FormGroup>
                                      </div>
                                      {showCombinationArray && (
                                        <div className="col  add-form">
                                          <FormGroup className="m-0">
                                            <div className="d-flex w-100">
                                              <div className="custom-react-select common-react-select flex-fill">
                                                <label htmlFor="tier1List" className="field-lbl bom-select-form bom-form-title asterisk-req">
                                                  {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.PRODUCT_SUPPLIER')}
                                                  {showCombinationArray && <span>*</span>}
                                                </label>

                                                <Select
                                                  name="tier1List"
                                                  options={t1SupplierListOptionsMemo}
                                                  getOptionLabel={(option) => `${option.name}`}
                                                  getOptionValue={(option) => `${option._id}`}
                                                  isOptionDisabled={(option) => option.isDisable}
                                                  value={suppColouref?.tier1Supplier}
                                                  isDisabled={!ele?.colourWayId}
                                                  onChange={(e) =>
                                                    handleChangeColorWay(
                                                      e,
                                                      colurwaysAsSuppliersPath(colInd, chInd, 'tier1Supplier').COLOURWAY_AS_SUPPLIERS,
                                                      'tier1Supplier',
                                                    )
                                                  }
                                                  styles={customStyles}
                                                  placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.PRODUCT_SUPPLIER')}
                                                  isClearable
                                                  className="common-select"
                                                  classNamePrefix="common-select"
                                                  menuPosition="fixed"
                                                />
                                                <span className="error-message">{get(errorState, `[${colInd}][${chInd}].tier1Supplier`, '')}</span>
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>
                                      )}
                                      {showCombinationArray && (
                                        <div className="col add-form">
                                          <div className="d-flex">
                                            <FormGroup className="flex-fill m-0">
                                              <div className="custom-react-select common-react-select flex-fill">
                                                <label htmlFor="componentSupplier" className="field-lbl bom-select-form bom-form-title asterisk-req">
                                                  {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COMPONENT_SUPPLIER')}
                                                  {showCombinationArray && <span>*</span>}
                                                </label>
                                                <Select
                                                  name="componentSupplier"
                                                  options={componentSuppliersOPtionsMemo}
                                                  getOptionLabel={(option) => `${option.name}`}
                                                  getOptionValue={(option) => `${option._id}`}
                                                  isDisabled={!ele?.colourWayId || disabledCompoenntSupplier || !suppColouref?.tier1Supplier}
                                                  value={suppColouref?.componentSupplier}
                                                  onChange={(e) =>
                                                    handleChangeColorWay(e, colurwaysAsSuppliersPath(colInd, chInd, 'componentSupplier').COLOURWAY_AS_SUPPLIERS)
                                                  }
                                                  styles={customStyles}
                                                  placeholder={t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COMPONENT_SUPPLIER')}
                                                  isClearable
                                                  className="common-select"
                                                  classNamePrefix="common-select"
                                                  menuPosition="fixed"
                                                />
                                                <span className="error-message">{get(errorState, `[${colInd}][${chInd}].componentSupplier`, '')}</span>
                                              </div>
                                            </FormGroup>
                                          </div>
                                        </div>
                                      )}
                                      {!searchText ? (
                                        <div style={{ marginTop: 20 }} className="ml-16 add-form">
                                          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                                            <button type="button" aria-label="add" onClick={() => addNewColourArtWork(colInd)} className="btn mr-16 p-0">
                                              <i className="icon-Add f-24" />
                                            </button>
                                          </CustomTooltip>
                                          {ele.colourRefsDataAsPerSuppliers.length !== 1 && (
                                            <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                                              <button
                                                type="button"
                                                aria-label="delete"
                                                onClick={() => {
                                                  removeColourArtWork(colInd, chInd);
                                                }}
                                                className="btn p-0"
                                              >
                                                <i className="icon-Delete f-24" />
                                              </button>
                                            </CustomTooltip>
                                          )}
                                        </div>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ))
                            : null}
                          {get(checkSimilarColourwaysRefExist, `[${colInd}]`, false) && (
                            <span className="error-message"> {t('BOM_LIBRARY.BOM_COLOURWAY_COMPONENT.COMBINATION_ALREADY_EXISTS')}</span>
                          )}
                        </Card.Body>
                      </Accordion.Collapse>
                    </div>
                  </Card>
                </Accordion>
              </div>
            );
          })
        : null}
      {addColorWay && <CommonColorWayAdd onOpen={addColorWay} toogle={handleToggleColorPopup} imageUpload={() => {}} />}
    </>
  );
});

BomColourwaysComponent.displayName = 'BomColourwaysComponent';

export default BomColourwaysComponent;
